module.exports = __webpack_public_path__ + "static/media/ziegelmauer_tn.75693384.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/ziegelmauer_tn.jpg
// module id = 782
// module chunks = 0